import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useInView } from 'react-intersection-observer';
import CardComponentFile from '../../../cards/cardComponentFile/CardComponentFile';
import { useFilesStore } from '../../../../store/devices/FilesDevicesFromDB';
import { Device } from '../../../../types/Device';
import { useAuthStore } from '../../../../store/auth/auth';
import { useFilterFileStore } from '../../../../store/devices/fileFilterStote';
import { useFileCurrentTypeStore } from '../../../../store/devices/fileCurrentType';
import { useFileSelectionStore } from '../../../../store/devices/useSelectedRowKeysFilesRS';
import './style.css';
import DeleteFilesDOF from '../../../modals/deleteFile/DeleteFilesDOF';
import { useButtonDeleteFromDOF } from '../../../../store/devices/useButtonsDeleteFromDOF';
import MoreDetails from '../../../modals/moreDetails/MoreDetalies';
import { useOpenMoreDetails } from '../../../../store/devices/useShowMoreDetails';
import { useRecordingState } from '../../leftSide/toolBar/api/recordingState';
import { useOnlineStateStream } from '../../../../store/devices/onlineStream';
import { Pagination, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

export interface FileTableProps {
    device: Device | null;
}

interface FileData {
    deviceUID: string;
    start: string;
    end: string;
    rating?: number[];
}

const FileTableLazy: React.FC<FileTableProps> = ({ device }) => {
    const { fileFilterStore } = useFilterFileStore();
    const { files, fetchFiles, resetFiles, hasMore, pagination, setPagination } = useFilesStore();
    const { user, SmartDVRToken } = useAuthStore();
    const { fileType } = useFileCurrentTypeStore();
    const { selectedFiles, setSelectedFiles } = useFileSelectionStore();
    const { isDeleteDeviceModal, setIsDeleteDeviceModal } = useButtonDeleteFromDOF();
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(100);
    const [isLoading, setIsLoading] = useState(true);
    const { openMoreDetails, setOpenMoreDetails } = useOpenMoreDetails();
    const { recordingType } = useRecordingState();

    const { ref, inView } = useInView({
        triggerOnce: false,
        threshold: 0.1,
    });

    const handleCheckboxChange = (fileId: string, checked: boolean) => {
        // Your logic for handling checkbox change
    };

    const fetchFilteredFiles = useCallback(
        async (currentPage = 1, currentPageSize = pagination.pageSize) => {
            if (!device || !user || !SmartDVRToken) return;
            setIsLoading(true);
            try {
                const params = {
                    deviceUID: device.UID,
                    start: fileFilterStore?.dateStart || '2024-02-27T20:22:49+05:00',
                    end: fileFilterStore?.dateEnd || '2099-12-14T23:59:59+05:00',
                    // start: fileFilterStore?.dateStart,
                    // end: fileFilterStore?.dateEnd,
                    rating:
                        fileFilterStore?.rating?.length > 0
                            ? fileFilterStore.rating.map(Number)
                            : undefined,
                    // fileType: fileType !== 'all' ? fileType : undefined,
                };

                await fetchFiles(params, SmartDVRToken, user.login, currentPage, currentPageSize);
            } catch (e) {
                console.log(e);
            } finally {
                setIsLoading(false);
            }
        },
        [device, fileFilterStore, fileType, user, SmartDVRToken],
    );

    const handlePageChange = async (page: number, pageSize: number) => {
        //@ts-ignore
        setPagination((prev) => ({ ...prev, current: page, pageSize }));
        await fetchFilteredFiles(page, pageSize); // Важно передать новую страницу
    };

    // const filteredFiles = useMemo(() => {
    //     let result = files;
    //
    //     // Фильтрация по типу файла
    //     if (fileType !== 'all') {
    //         result = result.filter((file) => file.fileType === fileType);
    //     }
    //
    //     // Фильтрация по рейтингу (если API не фильтрует)
    //     if (fileFilterStore?.rating && fileFilterStore.rating.length > 0) {
    //         const ratings = fileFilterStore.rating.map((r) => parseInt(r));
    //         result = result.filter((file) => file.rating && ratings.includes(file.rating));
    //     }
    //
    //     // Фильтрация по дате (если API не фильтрует)
    //     if (fileFilterStore?.dateStart || fileFilterStore?.dateEnd) {
    //         const startDate = fileFilterStore.dateStart
    //             ? new Date(fileFilterStore.dateStart)
    //             : null;
    //         const endDate = fileFilterStore.dateEnd ? new Date(fileFilterStore.dateEnd) : null;
    //
    //         result = result.filter((file) => {
    //             const fileDate = new Date(file?.start); // или другое поле с датой файла
    //             return (!startDate || fileDate >= startDate) && (!endDate || fileDate <= endDate);
    //         });
    //     }
    //
    //     return result;
    // }, [files, fileType, fileFilterStore]);

    const filteredFiles = useMemo(() => {
        if (fileType === 'all') {
            return files;
        }
        return files.filter((file) => file.fileType === fileType);
    }, [files, fileType]);

    // Сброс при изменении фильтров или устройства
    // useEffect(() => {
    //     //@ts-ignore
    //     setPagination((prev) => ({ ...prev, current: 1, pageSize: pagination.pageSize }));
    //     // resetFiles();
    //     fetchFilteredFiles(1);
    // }, [device, fileFilterStore, fileType]);
    // }, [device, fileFilterStore, fileType]);
    useEffect(() => {
        const timer = setTimeout(() => {
            fetchFilteredFiles(1);
        }, 300); // Дебаунс для избежания множественных запросов

        return () => clearTimeout(timer);
    }, [device?.UID, fileFilterStore]);

    const handleOkDeleteFileModal = () => {
        setIsDeleteDeviceModal(false);
        useFileSelectionStore.getState().clearSelectedFiles();
        fetchFilteredFiles(); // Обновляем список файлов после удаления
    };

    const handleCancelDeleteFileModal = () => {
        setIsDeleteDeviceModal(false);
    };
    const onCloseMoreDetails = () => {
        setOpenMoreDetails(false);
        useOnlineStateStream.getState().setIsStreamOnline(true);
    };

    const onOkMoreDetails = () => {
        setOpenMoreDetails(false);
        fetchFilteredFiles(1);
    };

    if (isLoading) {
        return (
            <div className="player-loading">
                <Spin
                    tip="Загрузка файлов..."
                    indicator={<LoadingOutlined className={'spin-icon'} spin />}
                />
            </div>
        );
    }

    return (
        <div className="FileTable">
            <div className="allDevice">
                {filteredFiles.length === 0 && !isLoading ? (
                    <div className="no-files-message">Файлов не обнаружено</div>
                ) : (
                    <>
                        <div className="allDevice">
                            {recordingType && (
                                <div className="recording-placeholder">
                                    <div className="recording-message">
                                        <h3>
                                            Идет запись{' '}
                                            {recordingType === 'video' ? 'видео' : 'аудио'}
                                        </h3>
                                        <p>
                                            Новый файл появится здесь после завершения записи и
                                            последующей обработки
                                        </p>
                                    </div>
                                </div>
                            )}
                            {filteredFiles?.length > 0 && (
                                <div
                                    style={{
                                        // display: 'flex',
                                        // justifyContent: 'center',
                                        marginBottom: 20,
                                    }}
                                >
                                    <Pagination
                                        current={pagination.current}
                                        pageSize={pagination.pageSize}
                                        total={pagination.total}
                                        onChange={handlePageChange}
                                        onShowSizeChange={handlePageChange}
                                        showSizeChanger
                                        showTotal={(total, range) =>
                                            `${range[0]}-${range[1]} из ${total}`
                                        }
                                        pageSizeOptions={[50, 100, 200]}
                                    />
                                </div>
                            )}
                            {filteredFiles.map((file: any) => (
                                <CardComponentFile
                                    key={file.ID}
                                    file={file}
                                    isSelected={!!selectedFiles[file.UID]}
                                    onCheckboxChange={handleCheckboxChange}
                                    onFileUpdated={fetchFilteredFiles}
                                />
                            ))}
                            {hasMore && <div ref={ref} style={{ height: '1px' }} />}
                        </div>
                        {isLoading && <div>Загрузка дополнительных файлов...</div>}
                    </>
                )}
                {hasMore && <div ref={ref} style={{ height: '1px' }} />}
            </div>

            {/*{isLoading && <div>Загрузка...</div>}*/}
            <DeleteFilesDOF
                visible={isDeleteDeviceModal}
                files={selectedFiles}
                onOk={handleOkDeleteFileModal}
                onCancel={handleCancelDeleteFileModal}
            />

            <MoreDetails
                onOk={onOkMoreDetails}
                open={openMoreDetails}
                onCancel={onCloseMoreDetails}
            />
        </div>
    );
};
export default FileTableLazy;
